import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { useSearchParams } from "react-router-dom";

const PersistSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState("");
  const searchkey = searchParams.get("searchkey") || "";
  const newParams = new URLSearchParams(searchParams);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (value === "") {
      newParams.delete("searchkey");
      setSearchParams(newParams);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (searchText.trim()) {
        newParams.set("searchkey", searchText.trim());
      } else {
        newParams.delete("searchkey");
      }

      setSearchParams(newParams);
    }
  };

  return (
    <div className="user-pro-search">
      <Form.Control
        type="search"
        placeholder="Search"
        className="form-control"
        defaultValue={searchkey ? searchkey : searchText}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default PersistSearch;
